import React, { Component } from 'react'
import { Form, Table, Icon, Divider } from 'semantic-ui-react'
import debounce from 'lodash.debounce'
import PayfazzPagination from '../../module/PayfazzPagination'
import Main from '../../Main'
import UserTableRow from './UserTableRow'
import './datauser.css'

import { API_QUERY_USER, API_QUERY_USER_BY_NIK } from '../../api'

class Datauser extends Component {
  constructor(props){
    super(props);
    this.state = {
      userData: [],
      userQuery: '',
      queryBy: 'nik',
      currentPage: 1,
      totalPage: 0,
      errorMsg: null,
      groupStatus: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage ){
        this.getQueryUser(this.state.userQuery, this.state.currentPage)
    }
  }

  getQueryUserByNik = (setQuery, setPage) => {
    let setParams = {
      query: setQuery,
      page: setPage
    }

    API_QUERY_USER_BY_NIK(setParams)
      .then((response) => {
        let check_group = response.data.data[0].groups.filter(x => 
         ( x.groupCode === 'social' && x.groupStatus === 'verified' ) ||
         ( x.groupCode === 'ktp' && x.groupStatus === 'verified')
        )
        console.log(check_group)
        if(check_group.length !== 2){
          return this.setState({
            userData: response.data.data,
            currentPage: response.data.pagination.currentPage,
            totalPage: response.data.pagination.totalPage,
            groupStatus: true
          })
        }
        return this.setState({
          userData: response.data.data,
          currentPage: response.data.pagination.currentPage,
          totalPage: response.data.pagination.totalPage
        })
      })
      .catch((error) => {
        if(error.response.status === 400) {
          this.setState({ errorMsg: error.response.data.message })
        }else{
          this.setState({ errorMsg: error.message })
        }
      })
  }

  getQueryUser = (setQuery, setPage) => {
    let setParams = {
      query: setQuery,
      page: setPage
    }

    API_QUERY_USER(setParams)
      .then((response) => {
        return this.setState({
          userData: response.data.data,
          currentPage: response.data.pagination.currentPage,
          totalPage: response.data.pagination.totalPage
        })
      })
      .catch((error) => {
        if(error.response.status === 400) {
          this.setState({ errorMsg: error.response.data.message })
        }else{
          this.setState({ errorMsg: error.message })
        }
      })
  }

  handleSubmitQuerySearch = (e) => {
    e.preventDefault()
    if(this.state.queryBy === 'nik'){
      this.getQueryUserByNik(this.state.userQuery, this.state.currentPage)
    }else{
      this.getQueryUser(this.state.userQuery, this.state.currentPage)
    }
  }

  handleChangQuerySearch = (e, { value }) => {
    if (value !== '')
    this.setState({userQuery: value })
  }

  handleChangQuerySearchBy = (e, { value }) => this.setState({ queryBy: value })

  handlePagePrev = debounce( () => {
    this.setState({ currentPage: this.state.currentPage - 1})
  }, 250, { 'maxWait': 1000 })

  handlePageNext = debounce( () => {
    this.setState({ currentPage: this.state.currentPage + 1})
  }, 250, { 'maxWait': 1000 })

  render() {
    const { userData, groupStatus, currentPage, totalPage, userQuery, errorMsg } = this.state;

    if (errorMsg){ return <Main><Divider horizontal>{errorMsg}</Divider></Main> }

    return (
      <Main>
        <h1 className="site__content__header">Search Data User</h1>

        <Form onSubmit={this.handleSubmitQuerySearch}>
          <Form.Group widths='equal'>
            <Form.Input fluid 
              icon={<Icon name='search' inverted circular link />}
              onChange={this.handleChangQuerySearch}
              defaultValue={userQuery}
              size="small"
              name='search'
              placeholder="Search by userId, username, email or phone number" />
          </Form.Group>
          

        </Form>

        {
          userData.length >= 1 ?
            <Table singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Username</Table.HeaderCell>
                  <Table.HeaderCell>Email</Table.HeaderCell>
                  <Table.HeaderCell>Phone Number</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                  <Table.HeaderCell>Created</Table.HeaderCell>
                  <Table.HeaderCell>Updated</Table.HeaderCell>
                  <Table.HeaderCell>Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                { userData.map( (data, i) =>
                  <UserTableRow
                    key={i}
                    propsData={data}
                    groupStatus={groupStatus}
                  />
                )}
              </Table.Body>
            </Table>
          : <Divider horizontal>Empty</Divider>
        }

        <PayfazzPagination
          currentPage={currentPage}
          totalPage={totalPage}
          handlePagePrev={this.handlePagePrev}
          handlePageNext={this.handlePageNext}
        />

      </Main>
    );
  }
}

export default Datauser;



// WEBPACK FOOTER //
// ./src/app/component/Datauser/index.js